import ReactDOM from 'react-dom';
import React from 'react';
import { SubmissionDirectoryErrorModal } from '../../../../../../client/features/SubmissionDirectoryErrorModal/index';

export const submissionDirectoryErrorModal = (function () {
  let $elemID,
    $isInit = false;

  const init = (elemID, data, container = 'body') => {
    $isInit = false;
    $elemID = elemID;
    if ($(`#${elemID}`).length) {
      destroy(elemID);
    } else {
      $(`<div id="${elemID}" />`).appendTo(container);
    }

    ReactDOM.render(
      React.createElement(SubmissionDirectoryErrorModal, {
        title: data.title,
        thumbnailImageUri: data.thumbnailImageUri,
        standartId: data.standartId,
        createDate: data.createDate,
        directoryName: data.directoryName,
        statusMessage: data.statusMessage,
        onClose: () => destroy(elemID)
      }),
      document.getElementById(elemID)
    );
    $isInit = true;
  };

  const destroy = (elemID) => {
    ReactDOM.unmountComponentAtNode(document.getElementById(elemID));
    $isInit = false;
  };

  return {
    init,
    destroy
  };
})();
